// @ts-expect-error - TS2339 - Property 'Ajax' does not exist on type 'Window & typeof globalThis'.
export default window.Ajax;
